module.exports = {"371621001":"孙武街道","371621003":"何坊街道","371621101":"石庙镇","371621102":"桑落墅镇","371621103":"淄角镇","371621104":"胡集镇","371621105":"李庄镇","371621107":"麻店镇","371621108":"魏集镇","371621109":"清河镇","371621111":"姜楼镇","371621113":"辛店镇","371621114":"大年陈镇","371621115":"皂户李镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371621.json
// module id = 1495
// module chunks = 0